import { render, staticRenderFns } from "./RightTable.vue?vue&type=template&id=6f726058&scoped=true&"
import script from "./RightTable.vue?vue&type=script&lang=js&"
export * from "./RightTable.vue?vue&type=script&lang=js&"
import style0 from "./RightTable.vue?vue&type=style&index=0&id=6f726058&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f726058",
  null
  
)

export default component.exports